import { DatePipe } from "@angular/common";
import { Component, computed, input } from "@angular/core";
import { RouterModule } from "@angular/router";

import { TranslateTokenPipe } from "../../../../core/pipes";
import { Constants } from "../../../constants/constants";
import { IntpCountryVisitModel } from "../../../models";
import { PictureComponent } from "../../general";

@Component({
  selector: "adaa-intp-dashboard-visits-timeline",
  imports: [RouterModule, DatePipe, TranslateTokenPipe, PictureComponent],
  templateUrl: "./intp-dashboard-visits-timeline.html",
  styleUrl: "./intp-dashboard-visits-timeline.scss",
})
export class IntpDashboardVisitsTimelineComponent {
  visits = input.required<IntpCountryVisitModel[]>();
  countryFlagId = input.required<number | undefined>();

  visitsTimeline = computed(() => this.visits().sort((a, b) => (a.startDate || 0) - (b.startDate || 0)));

  readonly Constants = Constants;
}
